import { Component, type ReactNode } from 'react'

/** Évite la page blanche : en cas d'erreur d'affichage, message + bouton pour recharger. */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('CS_ERROR_MSG:', error.message)
    console.error('CS_ERROR_STACK:', error.stack)
    console.error('CS_COMPONENT_STACK:', info.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy-900 text-white px-4" data-testid="error-boundary">
        <div className="max-w-md text-center space-y-4">
          <div className="w-14 h-14 mx-auto bg-gradient-to-br from-brand-orange to-red-600 rounded-xl flex items-center justify-center font-display font-bold text-2xl">CS</div>
          <h1 className="font-display text-2xl font-bold">Oups, un souci d'affichage</h1>
          <p className="text-slate-300 text-sm">La page n'a pas pu s'afficher correctement. Rechargez-la ; si le problème continue, revenez à l'accueil.</p>
          <p className="text-[11px] text-slate-500 font-mono break-all" data-testid="error-detail">{String(this.state.error.message).slice(0, 200)}</p>
          <p className="text-[10px] text-slate-600 font-mono break-all text-left whitespace-pre-wrap" data-testid="error-stack">{String((this.state.error as Error & { stack?: string }).stack ?? '').slice(0, 400)}</p>
          <div className="flex justify-center gap-3">
            <button type="button" onClick={() => { try { localStorage.removeItem('cs_cart_v2'); localStorage.removeItem('cs_promo_code_v2') } catch { /* bloqué */ } window.location.reload() }} className="btn-primary" data-testid="error-reload">Recharger la page</button>
            <a href="/" className="btn-light" data-testid="error-home">Accueil</a>
          </div>
        </div>
      </div>
    )
  }
}
